export default __webpack_public_path__ + "static/media/whiteAlLogo.a3eadeef.png";